import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import { DateFormaterMonth } from '../../Utils/GlobalFunction';
import { NoRecords, TableRows } from '../../Utils/Shimmer';

const Orders = () => {
    const [order, setOrder] = useState([]);
    const [limit] = useState(5); // Set a proper limit for pagination
    const { apiURL, apiHeaderJson, customer_id } = useContext(ConfigContext);
    const [pagination, setPagination] = useState({ page: 1, total_pages: 1 });
    const [loadingList, setLoadingList] = useState(false);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.total_pages) {
            setPagination((prev) => ({ ...prev, page: newPage }));
        }
    };

    const GetData = async () => {
        setLoadingList(true)
        const headers = apiHeaderJson;
        try {
            const response = await axios.get(`${apiURL}Customers/GetCustomerOrders`, {
                params: { limit, page: pagination.page },
                headers
            });

            setOrder(response.data.data);
            setPagination((prev) => ({
                ...prev,
                total_pages: response.data.total_pages || 1,
            }));
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoadingList(false);
        }
    };

    useEffect(() => {
        GetData();
    }, [customer_id, pagination.page]); // Updates when page changes

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="mb-0">Your Orders</h3>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Order</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Total</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loadingList ? <TableRows rows={limit} colSpan={12} /> :
                                    order.length > 0 ?
                                        order?.map((items) => (
                                            <tr key={items?.order_id}>
                                                <td>{items?.order_id}</td>
                                                <td>{DateFormaterMonth(items?.order_created_date.split(" ")[0])}</td>
                                                {/* <td><span> {items?.order_status_label}</span></td> */}
                                                <td>
                                                    <span>
                                                        {items?.order_status_label?.trim() ? items.order_status_label : '-'}
                                                    </span>
                                                </td>
                                                <td>{items?.order_grand_total}</td>
                                                <td>
                                                    <NavLink to={`/Invoice/${items.order_id}`} className="btn btn-sm">View</NavLink>
                                                </td>
                                            </tr>
                                        ))
                                        : (
                                            <tr>
                                                <td colSpan={8}>
                                                    <NoRecords />
                                                </td>
                                            </tr>
                                        )
                            }
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="pagination-area" style={{ marginBottom: '30px' }}>
                            <nav>
                                <ul className="pagination justify-content-start">
                                    {/* Previous Button */}
                                    <li className={`page-item ${pagination.page === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(pagination.page - 1)}>
                                            <i className="fi-rs-arrow-small-left" />
                                        </button>
                                    </li>

                                    {/* Page Numbers: Show (current - 1), current, (current + 1) */}
                                    {[...Array(pagination.total_pages)].map((_, i) => {
                                        const pageNumber = i + 1;
                                        if (
                                            pageNumber === pagination.page || // Current Page
                                            pageNumber === pagination.page - 1 || // One Before
                                            pageNumber === pagination.page + 1 // One After
                                        ) {
                                            return (
                                                <li key={pageNumber} className={`page-item ${pagination.page === pageNumber ? 'active' : ''}`}>
                                                    <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                                                        {pageNumber}
                                                    </button>
                                                </li>
                                            );
                                        }
                                        return null;
                                    })}

                                    {/* Next Button */}
                                    <li className={`page-item ${pagination.page === pagination.total_pages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(pagination.page + 1)}>
                                            <i className="fi-rs-arrow-small-right" />
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Orders;
